"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMonthUnit = getMonthUnit;
exports.getDateFormat = getDateFormat;
exports.getMonthFormat = getMonthFormat;

var _constants = require("../constants");

function getMonthUnit(calendarSystem) {
  return calendarSystem === _constants.CALENDAR_SYSTEM_JALALI ? 'jMonth' : 'month';
}

function getDateFormat(calendarSystem) {
  return calendarSystem === _constants.CALENDAR_SYSTEM_JALALI ? 'jYYYY-jMM-jDD' : 'YYYY-MM-DD';
}

function getMonthFormat(calendarSystem) {
  return calendarSystem === _constants.CALENDAR_SYSTEM_JALALI ? 'jYYYY-jMM' : 'YYYY-MM';
}